import { ProductForm, SEL_FORM_CONTAINER } from "../objects/product/product-form";
import { Section } from "../tools/section";
import { ProductGallery } from "../objects/product/product-gallery";
import { PersonalisationOptionForm } from "../personalisation-engine/personalisation-option-form";

const SEL_TEMPLATE_CONTAINER = '[data-product-form-section]';
const SELECTOR_MEDIA_SLIDER = '[data-product-gallery]';

class ProductTemplate extends Section {
  private formElement: HTMLFormElement | null = null;
  private form: ProductForm | null = null;
  private carousel: ProductGallery | null = null;
  carouselContainer: HTMLDivElement | null = null;

  queryChildren(container: HTMLElement): void {
    this.formElement = container.querySelector(SEL_FORM_CONTAINER);
    this.carouselContainer = container.querySelector(SELECTOR_MEDIA_SLIDER);

    this.bundleOptionForm = container.querySelector('bundle-builder-option');
    this.bundleBuilder = container.querySelector('bundle-builder');
  }

  attachEvents(container: HTMLElement): void {
    if (this.formElement) {
      this.form = new ProductForm(this.formElement);
    }


    if (this.bundleBuilder) {

      this.bundleOptionForm?.addEventListener('variant_change', (e) => {
        this.handleBundleVariantChange(e);
      });

      this.bundleBuilder?.addEventListener('variant_change', (e) => {
        this.handleBundleVariantChange(e)
      });
    }

    if (this.carouselContainer && this.form) {
      this.carousel = new ProductGallery(this.carouselContainer,this.form);
    }

    const personalisationOptionElem = document.querySelector('personalisation-option') as PersonalisationOptionForm;
    if (personalisationOptionElem) {
    }
  }

  handleBundleVariantChange(e) {
    const { addGlass } = e.detail;
    this.bundleBuilder?.setGlassProduct(addGlass);
    this.bundleOptionForm.setActiveOption(addGlass);
    const goToSlide = addGlass ? 1 : 0;
    this.carousel?.carousel?.slider?.moveToSlide(goToSlide);
  }

  getCarouselInstance(): ProductGallery | null {
    return this.carousel;
  }

  detatchEvents() {
    if (this.form) this.form.detatchEvents();
  }
}

Section.register(SEL_TEMPLATE_CONTAINER, ProductTemplate);